import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/ui-blocks/Reveal";
import { Button } from "@/components/ui/button";
import { ShieldCheck, FileCheck2, Landmark, ArrowRight } from "lucide-react";

export const TransparencyStrip = () => (
  <section className="relative navy-band text-white overflow-hidden">
    <div className="absolute inset-0 grain" aria-hidden="true" />
    <div className="container-wide relative py-14 lg:py-16">
      <div className="grid gap-8 lg:grid-cols-12 items-center">
        <div className="lg:col-span-7">
          <div className="eyebrow text-[hsl(var(--orange))]">Transparency & Accountability</div>
          <h3 className="heading-2 text-white mt-2">93% of every rupee spent reaches our beneficiaries.</h3>
          <p className="text-white/80 mt-3 max-w-2xl">A live public donation ledger from day one. Statutory audit as mandated for Section 8 companies — first report due FY 2026-27.</p>
          <Reveal delay={0.05}>
            <div className="mt-6 grid grid-cols-3 gap-4 max-w-2xl">
              <Card Icon={ShieldCheck} label="Statutory audit" value="First report FY 2026-27" />
              <Card Icon={FileCheck2} label="Impact reports" value="Program-wise" />
              <Card Icon={Landmark} label="Compliance" value="12A • 80G • CSR-1" />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:pl-8">
          <Reveal delay={0.1}>
            <div className="rounded-xl border border-white/15 bg-white/5 p-6">
              <div className="text-xs uppercase tracking-widest text-white/60">Where your ₹100 goes</div>
              <div className="mt-3 space-y-2 text-sm">
                {[["Programs & beneficiaries", 93, "hsl(var(--orange))"], ["Governance & compliance", 4, "hsl(var(--green))"], ["Fundraising & comms", 3, "#7FB6E8"]].map(([label, pct, color]) => (
                  <div key={label}>
                    <div className="flex items-center justify-between text-white/85"><span>{label}</span><span>₹{pct}</span></div>
                    <div className="h-2 mt-1 rounded-full bg-white/10 overflow-hidden">
                      <div className="h-full" style={{ width: `${pct}%`, background: color }} />
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-5"><Link to="/transparency"><Button data-testid="transparency-strip-cta" className="bg-[hsl(var(--orange))] hover:bg-[hsl(var(--orange-2))] text-black font-semibold">View Transparency <ArrowRight className="h-4 w-4 ml-1.5" /></Button></Link></div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

const Card = ({ Icon, label, value }) => (
  <div className="rounded-lg border border-white/15 bg-white/5 p-3">
    <div className="h-9 w-9 rounded-md bg-white/10 grid place-items-center text-[hsl(var(--orange))]"><Icon className="h-4.5 w-4.5" /></div>
    <div className="mt-3 text-white text-sm font-semibold">{value}</div>
    <div className="text-[11px] text-white/70">{label}</div>
  </div>
);
